/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-tile.html";

import "@nuskin/ns-style-elements";

/**
 * The ns-tile should be used for
 *
 * <h1>tile</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-tile class="demoElement"></ns-tile>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsTile extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  static get is() {
    return "ns-tile";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      background: {
        type: String
      },
      link: {
        type: String
      },
      scrimCopyFontSize: {
        type: String,
        value: "default",
        reflectToAttribute: true
      },
      imageAltText: {
        type: String,
        value: "Default Image Alt Text"
      }
    };
  }
}
customElements.define(NsTile.is, NsTile);
